import styled from 'styled-components';
import { Box } from '../Box/Box.es.js';
import { spacing } from '../../utils/theme.es.js';
var Grid = styled(Box).withConfig({
  componentId: "gvtjmk-0"
})(["display:grid;grid-template-columns:repeat(auto-fill,", "px);gap:", ";> div,> a{margin:0;}"], function (_ref) {
  var columnWidth = _ref.columnWidth;
  return columnWidth;
}, function (_ref2) {
  var _ref2$gutter = _ref2.gutter,
      gutter = _ref2$gutter === void 0 ? "md" : _ref2$gutter;
  return spacing(gutter);
});
Grid.displayName = "Grid";
export { Grid };